import { useState } from 'react';

const STOP_LOSS_CHANGE_KEY = 'slc';

const useStopLoss = () => {
  const [isStopLoss, setIsStopLoss] = useState(
    Boolean(sessionStorage.getItem(STOP_LOSS_CHANGE_KEY)),
  );

  const clearStopLossChange = () => {
    sessionStorage.removeItem(STOP_LOSS_CHANGE_KEY);
    setIsStopLoss(false);
  };

  const setIsStopLossChange = () => {
    setIsStopLoss(true);
    sessionStorage.setItem(STOP_LOSS_CHANGE_KEY, 'true');
  };

  return {
    isPotentialStopLossChange: isStopLoss,
    setIsStopLossChange,
    clearStopLossChange,
  };
};

export default useStopLoss;
